<div class="hero-campaign-card"
  (click)="redirectToUrl()">
  <h3 class="hero-campaign-card__title">{{ title | translate }}</h3>
  <p class="hero-campaign-card__description">{{ description | translate }}</p>
  <rmx-icon name="arrow-right-line"
    class="hero-campaign-card__arrow"></rmx-icon>
</div>
